// extracted by mini-css-extract-plugin
export default {"fullPageContainer":"FullPageContainer_fullPageContainer__fYeqQ","pageContainer":"FullPageContainer_pageContainer__xgTIy"};